var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-warp"},[_c('el-container',[_c('el-header',[_vm._v("后台管理系统"),_c('div',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("登出")])]),_c('el-container',{staticClass:"index-content"},[_c('el-aside',{attrs:{"width":"200px"}},[_c('Nav')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }